<template>
  <div class="row justify-content-center mt-md-5">
    <div class="row justify-content-center col-12 col-md-8">
      <div class="col-12">
        <div class="modal-header-content">
          <div class="ml-md-2 d-flex align-items-end justify-content-end mt-auto">
            <img :src="require(`@/assets/images/b122/img-watcher-right.png`)" class="step-img">
          </div>
          <div class="container-title">
            <h1 class="page-title subtitle-step0">{{ $t('annonce.Declare.Title') }}</h1>
          </div>
        </div>
        <!-- region Grand écrans -->
        <div class="row mt-4 mb-3 d-none d-md-flex">
          <div class="col-6">
            <p class="local-subtitle bold-text">{{ $t('annonce.Declare.Complete.Title') }}</p>
            <li class="main-grey-light-color">{{ $t('annonce.Declare.Complete.Doc.Complaint') }}</li>
            <li class="main-grey-light-color">{{ $t('annonce.Declare.Complete.Doc.GreyCard') }}</li>
          </div>
          <div class="col-6">
            <p class="local-subtitle bold-text">{{ $t('annonce.Declare.Partial.Title') }}</p>
            <p class="main-grey-light-color">{{ $t('annonce.Declare.Partial.Content') }}</p>
          </div>
        </div>
        <div class="row d-none d-md-flex">
          <div class="col-6">
            <b-button class="w-100" variant="primary" @click="setMaxStep('complete')">
              <div>{{ $t('annonce.create.Full') }}</div>
            </b-button>
          </div>
          <div class="col-6">
            <b-button class="w-100" variant="outline-primary" @click="setMaxStep('fast')">
              <div>{{ $t('annonce.create.Fast') }}</div>
            </b-button>
          </div>
        </div>
        <!-- endregion-->
        <!-- region petits écrans -->
        <div class="mt-4 mb-3 d-block d-md-none">
          <div class="col pl-0 pr-0 custom-border-bottom mb-3">
            <p class="local-subtitle bold-text">{{ $t('annonce.Declare.Complete.Title') }}</p>
            <li class="main-grey-light-color">{{ $t('annonce.Declare.Complete.Doc.Complaint') }}</li>
            <li class="main-grey-light-color">{{ $t('annonce.Declare.Complete.Doc.GreyCard') }}</li>
            <b-button class="mt-2 w-100" variant="primary" @click="setMaxStep('complete')">
              <div>{{ $t('annonce.create.Full') }}</div>
            </b-button>
          </div>
          <div class="col pl-0 pr-0">
            <p class="local-subtitle bold-text">{{ $t('annonce.Declare.Partial.Title') }}</p>
            <p class="main-grey-light-color">{{ $t('annonce.Declare.Partial.Content') }}</p>
            <b-button class="w-100" variant="outline-primary" @click="setMaxStep('fast')">
              <div>{{ $t('annonce.create.Fast') }}</div>
            </b-button>
          </div>
        </div>
        <!--endregion-->
        <!-- region modale explications -->
        <div class="col mt-5 d-md-none custom-col-12 cursor-pointer" @click="$bvModal.show('annonce-success-modal')">
          <div class="d-flex justify-content-start align-items-center">
            <i class="ph ph-custom ph-question ph-custom-size"></i>
            <span class="page-title custom-span-mobile ml-2">{{ $t("annonce.Declare.Success.Title") }}</span>
          </div>
        </div>
        <!-- endregion -->
      </div>
    </div>
    <!-- region explications grand écran -->
    <div class="row justify-content-start col-12 col-md-8 mt-4 d-none d-md-block">
      <div class="col-12 custom-col-12 ">
        <div><span class="page-title">{{ $t("annonce.Declare.Success.Title") }}</span></div>
        <p class="mt-3 secondary-text-color" v-html="$t('annonce.Declare.Success.Text')"></p>
      </div>
    </div>

    <div class="row justify-content-start col-12 col-md-8 d-none d-md-flex">
      <div class="col-6">
        <div class="d-flex align-items-start">
          <i class="ph-custom ph-check-circle main-color custom-size-icon mt-1"/>
          <p class="ml-2 secondary-text-color" v-html="$t('annonce.Declare.Success.Check')"></p>
        </div>
      </div>
      <div class="col-6">
        <div class="d-flex align-items-start">
          <i class="ph-custom ph-x-circle main-red-color custom-size-icon mt-1"/>
          <p class="ml-2  secondary-text-color" v-html="$t('annonce.Declare.Fail.X')"></p>
        </div>
      </div>
    </div>
    <!--endregion-->
    <annonce-success-modal-step0></annonce-success-modal-step0>
  </div>
</template>

<script>
import AnnonceSuccessModalStep0 from "../AnnonceSuccessModalStep0";
import AnnonceCreationUtils from "../../../utils/AnnonceCreationUtils";

export default {
  name: "AnnonceCreateStep0",

  components: {
    AnnonceSuccessModalStep0
  },

  emits: ["setMaxStep"],

  data() {
    return {
      AnnonceCreationUtils: AnnonceCreationUtils,
    }
  },

  methods: {

    setMaxStep(creationType) {
      this.$emit('setMaxStep', creationType)
    }
  }

}
</script>

<style scoped>


.modal-header-content {
  background-color: var(--main-black-medium);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1em 1em 0;
  border-bottom: none;
  border-radius: 30px;
}

.custom-border-bottom {
  padding-bottom: 1em;
  border-bottom: 1px solid var(--main-grey-dark);
}

.custom-size-icon {
  font-size: 26px;
}

.step-img {
  max-width: 400px;
  width: 100%;
}

.container-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
  padding-bottom: 0.5em;
}

.ph-custom-size {
  font-size: 28px;
}

.subtitle-step0 {
  font-size: 40px;
  line-height: 40px;
}

.local-subtitle {
  font-size: var(--title-level-two-font-size);
}

@media (max-width: 1200px) {
  .subtitle-step0 {
    font-size: 32px;
  }
}

@media (max-width: 992px) {
  .subtitle-step0 {
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .step-img {
    max-width: 200px;
  }

  .custom-span-mobile {
    font-family: "KumbhSans-Regular", "Arial", sans-serif;
    font-weight: 400;
    font-size: 16px;
  }

  .custom-col-12 {
    border: 1px solid var(--main-grey-light);
    border-radius: 15px;
    gap: 10px;
    padding: 10px;
  }
}

@media (max-width: 576px) {
  .subtitle-step0 {
    font-size: 24px;
  }
}


</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceCreate/AnnonceCreateStep0.vue